import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Nombres del padrón `comerciales` (quienes ingresaron como Comercial), para elegir
 * por cuenta de qué comercial carga una orden quien no lo es (trader, middle
 * office, admin). Lo usan todos los formularios de carga de órdenes.
 *
 * Con `enabled` en false no abre la suscripción: un comercial (o un productor, que
 * opera con ese rol) no elige comercial y las reglas no le dejan leer el padrón.
 */
export const useNombresComerciales = (enabled) => {
    const [nombres, setNombres] = useState([]);

    useEffect(() => {
        if (!enabled) return undefined;
        return onSnapshot(collection(db, 'comerciales'), (snapshot) => {
            const lista = snapshot.docs
                .map(d => d.data())
                .filter(c => c.active !== false && c.nombre)
                .map(c => c.nombre);
            setNombres([...new Set(lista)].sort((a, b) => a.localeCompare(b, 'es')));
        }, (error) => {
            console.error('useNombresComerciales: no se pudo leer el padrón de comerciales:', error);
        });
    }, [enabled]);

    return nombres;
};
